import styled from "styled-components";

const ModalContent = styled.div`
  position: relative;
  z-index: 1;
  background: ${({ theme }) => theme.colors.background};
  width: 100%;
  max-width: 900px;
  margin: 1.5rem;
  padding: 2rem;
  max-height: calc(100% - 1.5rem);
  overflow: auto;
  border-radius: 5px;

  @media only screen and (max-width: 700px) {
    padding: 1rem;
  }
`;

export default ModalContent;
